import React, { useState } from "react";

import styled from "styled-components";

import Text from "components/atoms/text/Text";

import AbstractModal from "components/page/modal/AbstractModal";
import { ModalContainer, ModalDescText } from "components/page/modal/styled";

import { useNavigatorTagResourcesCreate, useNavigatorTags } from "hooks/queries/useNavigator";

const TagListWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    width: 100%;
    min-height: 180px;
    max-height: 300px;
    margin-top: 16px;
    overflow-y: auto;
`;

const TagItem = styled.button`
    margin: 0 4px 4px 0;
    padding: 6px;
    max-width: 240px;
    height: 28px;
    background-color: ${(props) => (props.$selected ? "var(--color-TagActive)" : "var(--color-Tag)")};
    border: solid 1px ${(props) => (props.$selected ? "var(--color-Key)" : "transparent")};
    border-radius: 2px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

function NavigatorTagMultiAddModal({ exitModal, resources }) {
    const tagsQuery = useNavigatorTags();
    const tagResourcesCreate = useNavigatorTagResourcesCreate();
    const [selectedTagIds, setSelectedTagIds] = useState([]);

    const handleCheck = (id) => {
        if (selectedTagIds.includes(id)) {
            setSelectedTagIds(selectedTagIds.filter((item) => item !== id));
            return;
        }
        setSelectedTagIds([...selectedTagIds, id]);
    };

    const handleApply = () => {
        tagResourcesCreate.mutate(
            {
                tag_ids: selectedTagIds,
                resources,
                replace: false,
            },
            {
                onSuccess: exitModal,
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="태그 추가"
            width={480}
            exitModal={exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "적용",
                leftOnClick: exitModal,
                rightOnClick: handleApply,
            }}
        >
            <ModalContainer>
                <ModalDescText>선택한 항목에 추가할 태그를 선택해주세요.</ModalDescText>
                <TagListWrap>
                    {(tagsQuery.data || []).map((tag) => (
                        <TagItem
                            key={tag.id}
                            type="button"
                            $selected={selectedTagIds.includes(tag.id)}
                            onClick={() => handleCheck(tag.id)}
                        >
                            <Text variant="body-sm-400" color="var(--color-Black)" ellipsis>
                                {tag.name}
                            </Text>
                        </TagItem>
                    ))}
                </TagListWrap>
            </ModalContainer>
        </AbstractModal>
    );
}

export default NavigatorTagMultiAddModal;
